<!--
 * @Description: 选择区服角色
 * @Author: cooky
 * @Date: 2021-02-25 17:17:56
 * @LastEditors: cooky
 * @LastEditTime: 2021-03-15 16:01:00
-->
<template>
  <BasePop :title="$t('select_server_role')">
    <div class="tip-orange">{{ $t('please_select_regionrole') }}</div>
    <ServerRole/>
  </BasePop>
</template>
<script>
// import { getServerAndRole, setCurrentRole } from '@/api'
import { mapState, mapMutations, mapGetters } from 'vuex'
import BasePop from './base'
import ServerRole from './ServerRoleForm'
// import router from '@/router'
// import Vue from 'vue'
// import i18n from '@/i18n'
import Store from '@/store'

export default {
  name: 'BindRole',
  async beforeRouteEnter (to, from, next) {
    if (!sessionStorage.token) {
      next({ name: 'ThirdPartChannel' })
    } else if (!sessionStorage.roleId) {
      next({ name: 'RoleBinding' })
    } else {
      await Store.dispatch('GetAllRoles')
      console.log('beforeRouteEnter 绑定角色')
      const { roleId, serverName } = sessionStorage
      const { serverRoleList } = Store.getters
      if (serverName && serverRoleList.find(item => item.server_name === serverName)) {
        next({ name: 'buying' })
      } else if (roleId) {
        next()
      }
    }
    // if (!sessionStorage.token) {
    //   next({ name: 'ThirdPartChannel' })
    // } else {
    //   await Store.dispatch('GetAllRoles')
    //   console.log('beforeRouteEnter 选择区服')
    //   const { roleId, serverName } = sessionStorage
    //   const { serverRoleList } = Store.getters
    //   if (serverName && serverRoleList.find(item => item.server_name === serverName)) {
    //     next({ name: 'buying' })
    //   } else if (roleId) {
    //     next({ name: 'InfoBinding' })
    //   } else if (sessionStorage.token) {
    //     next({ name: 'RoleBinding' })
    //   }
    //   // if (Store.getters.roleId) {
    //   //   next({ name: 'InfoBinding' })
    //   // } else {
    //   //   next()
    //   // }
    // }
    // if (!sessionStorage.token) {
    //   next({ name: 'ThirdPartChannel' })
    // } else {
    //   await Store.dispatch('GetAllRoles')
    //   if (Store.getters.roleId) {
    //     next()
    //   } else {
    //     next({ name: 'RoleBinding' })
    //   }
    // }
  },
  components: {
    BasePop,
    ServerRole
  },
  data () {
    return {
      loading: false,
      modal: null
    }
  },
  computed: {
    ...mapState([
      'token',
      'lang',
      'roleId'
    ]),
    ...mapGetters(['serverName', 'roleName'])
  },
  async created () {
    // this.validateAndInit()
  },
  methods: {
    ...mapMutations([
      'SET_TOKEN',
      'SET_SERVER_NAME',
      'SET_ROLE_NAME',
      'SET_APP_ID'
    ])
  }
}
</script>
<style lang="less" scoped>
  .tip-orange {
    color:#e8691c;
    margin: 30px 0 46px;
  }

  @media screen and (max-width: 750px) {
   .select {
       margin-bottom: 4.8rem;
   }
   .tip-orange {
     margin: 4.5333rem 0 7.4667rem;
     font-size: 2.6667rem /* 20/7.5 */;
   }
}
</style>
